/**
 * @type {Partial<Record<string, number>>}
 */
  const config = {
    AT: 4,
    CH: 4,
  };

/**
 * @param {number | string} zip
 * @param {string} country
 */
  export const zipFilter = (zip, country) => {
    if (zip === -1) return '';

    if (typeof zip === 'number') {
      zip = zip.toString().padStart(2, '0');
    }

    const length = config[country] || 5;

    while (zip.length < length) {
      zip += 'x';
    }

    return zip;
  };
